import type { CommaDelimitedLocationType } from '../types';
import { useLocationControl } from './use_location_control';
import { useCallback } from 'react';
import { LocationControlResult } from '@grnhse/location-control';
import { Item } from '@grnhse/seedling/lib/birch/components/forms/dropdown';

interface FetchResult {
  items: Item<LocationControlResult>[];
}

export const useFetchLocations = (locationType: CommaDelimitedLocationType) => {
  const locationControl = useLocationControl(locationType);

  return useCallback(
    async (term: string): Promise<FetchResult> => {
      const locations = await locationControl.results(term);

      const items = locations.map((location) => ({
        label: location.displayName,
        value: location,
      }));

      return {
        items,
      };
    },
    [locationControl]
  );
};
